import React from 'react';

const safariRegex = /^((?!chrome|android).)*safari/i;

export function useBrowserIsSafari() {
    return React.useMemo(() => safariRegex.test(navigator.userAgent), []);
}
